var jlPlans = {
  load:function(holderID,options){
    this.options = options;
    this.holderID = this.holderID;
    this.holder = document.getElementById(holderID);
    this.planDivs = this.holder.querySelectorAll("div[data-plan]");
    this.planScroll = this.holder.parentNode;
    this.select(options.plan);
    this.events();
  },
  events:function(){
    this.planDivs.forEach(p=>{
      p.addEventListener("click",(e)=>{
        this.select(e.currentTarget.getAttribute("data-plan"));
      });
    });
  },
  select:function(plan){
    this.planID = plan;


    this.planDivs.forEach((d,index)=>{

      if(d.getAttribute("data-plan") == plan){

        if(index > 0){
          this.planScroll.scrollTo({left:600,behavior:"smooth"});
        }
        else{
          this.planScroll.scrollTo({left:0,behavior:"smooth"});
        }

        d.classList.add("selected");
        this.plan = {
          price:d.getAttribute("data-price"),
          priceString:d.getAttribute("data-priceString"),
          name:d.getAttribute("data-name"),
          id:d.getAttribute("data-plan"),
          description:d.getAttribute("data-description")
        };
      }
      else{
        d.classList.remove("selected");
      }

    });

    if(this.options.onChange){
      this.options.onChange(this.plan);
    }
  }
};
